<template>
  <v-row class="ma-0">
    <v-col class="pa-0 px-1 px-md-2">
      <v-expansion-panels
        class="pa-0 ma-0 mb-1"
        multiple
        id="profSubCategory"
      >
        <v-expansion-panel
          class="pa-0 ma-0 px-md-1"
        >
          <v-expansion-panel-header
            class="expansion-panel-header"
            v-slot="{ open }"
            expand-icon=""
          >
            <v-list class="wrap-text ma-0 pa-0">
              <v-list-item class="pa-0 pr-md-1">
                <v-list-item-avatar>
                  <v-img
                    max-width="50"
                    max-height="50"
                    :src="
                                subCategory.PictureUrl != null
                                  ? subCategory.PictureUrl
                                  : subCategory.Picture
                              "
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="subCategory.Name"
                    class="text-wrap homepageSubTitle"
                  >
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="!isMobile">
                              <span
                                v-html="subCategory.Description"
                                class="primary--text text-wrap text-body-1"
                              ></span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    small
                    color="secondary"
                    class="pa-0 pa-2 secondary-font-color">
                   <v-icon v-if="!open">mdi-chevron-double-down</v-icon>
                   <v-icon v-else>mdi-chevron-double-up</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item></v-list
            >
          </v-expansion-panel-header>
          <v-expansion-panel-content class="px-1 ma-0">
              <ProfessionalViewCategory :items="subCategory" :isSubCategory="true" name="ProfessionalViewCategory" @getShoppingLists="getShoppingLists">
              </ProfessionalViewCategory>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
import ProfessionalViewProduct from "@/components/event/professionalViewType/ProfessionalViewProduct.vue";
import ProfessionalViewCategories from "@/components/homepage/ProfessionalViewCategories.vue";

export default {
  name: 'ProfessionalViewSubCategory',
  components: {
    ProfessionalViewCategories,
    ProfessionalViewProduct,
    ProfessionalViewCategory: () => import("@/components/event/professionalViewType/ProfessionalViewCategory.vue"),
  },
  props: {
    subCategory: Object,
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  data() {
    return {

    }
  },
  methods:{
    getShoppingLists(){
      this.$emit('getShoppingLists');
    },
  },
}

</script>

<style scoped lang="scss">
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0px !important;
}
.expansion-panel-header {
  padding: 8px 8px 8px !important;
}
</style>
